/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Surviving source this lead's source was merged into. Absent when it was never merged; the lead keeps pointing at its original source either way.
 * @export
 * @interface LeadSourceMergedInto
 */
export interface LeadSourceMergedInto {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the LeadSourceMergedInto interface.
 */
export function instanceOfLeadSourceMergedInto(value: object): value is LeadSourceMergedInto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function LeadSourceMergedIntoFromJSON(json: any): LeadSourceMergedInto {
    return LeadSourceMergedIntoFromJSONTyped(json, false);
}

export function LeadSourceMergedIntoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadSourceMergedInto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function LeadSourceMergedIntoToJSON(json: any): LeadSourceMergedInto {
    return LeadSourceMergedIntoToJSONTyped(json, false);
}

export function LeadSourceMergedIntoToJSONTyped(value?: LeadSourceMergedInto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

